/**
 * When the live battle is saved as its suspended copy (keeper.ts `suspend`), beyond the page being hidden (M33).
 *
 * It used to be saved at wave breaks and when the page went out of sight. iOS closing the page in the foreground (out
 * of memory, a GPU process reset) sends neither, so a crash mid-wave lost everything since the last break — a long
 * boss stage is minutes. Now also: at every stage start, and every `EveryMs` of unpaused play. A save is a few
 * kilobytes of command log plus the save record's write, far below a frame's budget at this rate.
 *
 * Pure: the level loop passes its clock (ms), the sim's stage and whether it is paused.
 */
export class SnapshotCadence {
  static readonly EveryMs = 20_000;
  private last: number;
  private stage: number;

  constructor(nowMs: number, stage: number) { this.last = nowMs; this.stage = stage; }

  /** Whether to save now; a true answer restarts the interval. */
  due(nowMs: number, stage: number, paused: boolean): boolean {
    if (stage !== this.stage) { this.stage = stage; this.last = nowMs; return true; }
    if (paused || nowMs < this.last) { if (nowMs < this.last) this.last = nowMs; return false; }
    if (nowMs - this.last < SnapshotCadence.EveryMs) return false;
    this.last = nowMs;
    return true;
  }

  /** A save made another way (a wave break, the page hidden): the interval restarts from it. */
  saved(nowMs: number): void { this.last = nowMs; }
}
